import { UkIcon, PlIcon, RuIcon, UaIcon } from 'svg/flags';

export default {
	"pl": { svg: <PlIcon/>, label: "PL" },
	"en": { svg: <UkIcon/>, label: "EN" },
	"ru": { svg: <RuIcon/>, label: "RU" },
	"ua": { svg: <UaIcon/>, label: "UA" }
}